export default "__VITE_ASSET__D$BFNvh$__"